import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
import { TZyutyuHaisyaListGetRes } from "../../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import util from "../../../../ts/util"
import * as wjcCore from "@grapecity/wijmo"

const CardInfo: React.FC<{
  車輌乗務員: T車輌乗務員
  cardInfo: TZyutyuHaisyaListGetRes
  haisoTyuFlg?: boolean
  chip: string
}> = (props) => {
  const 分割受注配車情報 = props.車輌乗務員.分割受注配車情報
    ? props.車輌乗務員.分割受注配車情報.find(
        (b) => b.受注配車ID === props.cardInfo.受注配車ID
      )
    : undefined

  /* 運行部所が受注部所と違う場合表示 */
  let 表示部所 = ""
  if (props.cardInfo.受注部所コード !== props.cardInfo.運行部所コード) {
    表示部所 = props.cardInfo.運行部所名 ?? ""
  } else if (分割受注配車情報) {
    // 分割受注の存在していた場合も表示
    表示部所 = 分割受注配車情報.分割運行部所名
  }

  let 変更乗務員名 = ""
  if (props.cardInfo.乗務員ID !== props.車輌乗務員.乗務員ID) {
    変更乗務員名 = props.cardInfo.乗務員名 ?? ""
  }

  return (
    <Container fluid className="px-2">
      <Row>
        <Col xs={12}>
          {/* MEMO: 配送順確認用の記述 */}
          {false && (
            <>
              <div>
                {props.cardInfo.受注伝票番号}-{props.cardInfo.受注枝番}
              </div>
              {true && <div>内部配送順:{props.cardInfo.配送順}</div>}
            </>
          )}
          <table className="haisya-info-inner">
            {/* 配送中の場合配送中表示のみ */}
            {props.haisoTyuFlg ? (
              <tbody className="align-top">
                <tr>
                  <td className="fw-bold">配送中</td>
                </tr>
                <tr>
                  <td className="fw-bold">
                    {util.date.format(props.cardInfo.積日)} ~{" "}
                    {util.date.format(props.cardInfo.卸日)}
                  </td>
                </tr>
                <tr>
                  <td>
                    {/* tableはminheightが効いてないため強引に付与 */}
                    <div style={{ minHeight: "2rem" }}></div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {/* tableはminheightが効いてないため強引に付与 */}
                    <div style={{ minHeight: "2rem" }}></div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {/* tableはminheightが効いてないため強引に付与 */}
                    <div style={{ minHeight: "2rem" }}></div>
                  </td>
                  <td className="text-end">{props.children}</td>
                </tr>
              </tbody>
            ) : (
              <tbody className="align-top">
                <tr>
                  <td>{props.cardInfo.荷主コード}</td>
                  <td colSpan={3}>{props.cardInfo.荷主名}</td>
                  <td
                    className="text-end align-top"
                    style={{
                      fontSize: "1.4rem",
                    }}>
                    {props.cardInfo.繰返運行数 &&
                      props.cardInfo.繰返運行数 > 1 &&
                      `×${props.cardInfo.繰返運行数}`}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td colSpan={3}>
                    {util.addTextWithStartDelimiter(
                      props.cardInfo.積地社名 ?? "",
                      props.cardInfo.積地市区町村,
                      "/"
                    )}
                  </td>
                  <td className="text-danger text-center">
                    {分割受注配車情報 && 分割受注配車情報.請求対象フラグ === 1
                      ? 分割受注配車情報.分割車番 ?? "????"
                      : undefined}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td colSpan={3}>
                    {util.addTextWithStartDelimiter(
                      props.cardInfo.卸地社名 ?? "",
                      props.cardInfo.卸地市区町村,
                      "/"
                    )}
                  </td>
                  <td className="text-danger text-center">
                    {分割受注配車情報 && 分割受注配車情報.請求対象フラグ === 0
                      ? 分割受注配車情報.分割車番 ?? "????"
                      : undefined}
                  </td>
                </tr>
                <tr>
                  <td>
                    {" "}
                    <div style={{ minHeight: "2rem" }}></div>
                  </td>
                  <td colSpan={2}>{props.cardInfo.品名}</td>
                  {props.chip === "1" && (
                    <>
                      <td>
                        {props.cardInfo.積載品数量}
                        {props.cardInfo.積載品数量 &&
                          props.cardInfo.単位区分名称1 &&
                          props.cardInfo.単位区分名称1}
                      </td>
                    </>
                  )}
                  {props.chip === "2" && (
                    <>
                      <td className="text-danger">
                        {props.cardInfo.食事手当 != null &&
                          wjcCore.format("{食事手当:G}", props.cardInfo)}
                        {props.cardInfo.食事手当 && "円"}
                      </td>
                    </>
                  )}
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td className="text-danger">{表示部所}</td>
                  <td>{変更乗務員名}</td>
                  <td>{props.cardInfo.同乗者名}</td>
                  <td className="text-end">{props.children}</td>
                </tr>
              </tbody>
            )}
          </table>
        </Col>
      </Row>
    </Container>
  )
}

export default CardInfo
